export const autofillMixin = {
  methods: {
    getAutofillAttribute(item) {
      switch (item.dataDefinitionId) {
        case 5:
          return 'bday';
        case 9:
          return 'street-address';
        case 10:
          return 'postal-code';
        case 11:
          return 'address-level2';
        case 12:
          return 'country-name';
        case 13:
          return 'tel';
        case 14:
          return 'tel';
        default:
          return 'off';
      }
    }
  }
};
